// Scroll reveals. Add data-reveal to an element, or data-reveal-stagger to a grid so its
// children arrive one after another (optionally data-reveal="left|right" to slide in from a
// side). The hidden state and transitions are in app.css (the "Motion" section); this only
// adds `is-visible` when the element enters the viewport, once, and `is-done` after the
// transition so the element's own hover transitions work again.
const items = document.querySelectorAll('[data-reveal], [data-reveal-stagger]');

const show = (el) => {
    el.classList.add('is-visible');
    setTimeout(() => el.classList.add('is-done'), 1500);
};

if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(show);
} else {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    show(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.12, rootMargin: '0px 0px -6% 0px' },
    );

    items.forEach((el) => observer.observe(el));
}
